// src/asanaClient.js
import {
  ApiClient,
  UsersApi,
  WorkspacesApi,
  TasksApi,
  TimeTrackingEntriesApi,
  ProjectsApi,
} from 'asana';

/**
 * Returns an object with ready-to-use API helpers.
 * Works both with OAuth access_token and classic PAT.
 */
export function createAsanaClient(accessToken) {
  const client = new ApiClient();

  // pick available auth scheme
  const { authentications } = client;

  if (authentications.oauth2) {
    authentications.oauth2.accessToken = accessToken;   // OAuth flow
  } else if (authentications.token) {
    authentications.token.accessToken = accessToken;    // PAT flow
  } else {
    // fallback: inject Bearer header manually
    client.defaultHeaders = client.defaultHeaders || {};
    client.defaultHeaders.Authorization = `Bearer ${accessToken}`;
  }

  return {
    client,
    users:              new UsersApi(client),
    workspaces:         new WorkspacesApi(client),
    tasks:              new TasksApi(client),
    projects:           new ProjectsApi(client),
    timeTrackingEntries:new TimeTrackingEntriesApi(client),
  };
}
